import { useFeatureFlag } from 'hooks/featureFlags/useFeatureFlag';
import { FeatureFlag } from 'types';
import {
  dataManagementHrisConfigClient,
  marketpriceHrisConfigClient,
  type HrisConfigClient,
} from 'service/hrisConfigClient';

/**
 * Selects the HRIS config backend for the current tenant. The per-tenant
 * hris_data_management flag routes flipped tenants to the data-management
 * client once it exists; until then that client is absent and every tenant
 * (flag on or off) resolves to marketprice — so the flag can be flipped in
 * non-prod to exercise routing with no behavior change.
 */
export function useHrisConfigClient(): HrisConfigClient {
  const routeToDataManagement = useFeatureFlag(FeatureFlag.HRIS_DATA_MANAGEMENT);

  if (routeToDataManagement && dataManagementHrisConfigClient) {
    return dataManagementHrisConfigClient;
  }

  return marketpriceHrisConfigClient;
}
